import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Tab } from 'src/app/core/models/tab.model';
import { TabComponent } from './tab/tab.component';
@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  standalone: false,
})
export class TabsComponent implements OnInit {
  @Output() emitTabChange = new EventEmitter<Tab>();

  tabs: TabComponent[] = [];

  ngOnInit() {
    this.tabs[0].active = true;
  }

  selectTab(selectedTab: Tab) {
    this.tabs.forEach((tab) => {
      tab.active = false;
    });
    selectedTab.active = true;
    this.emitTabChange.emit(selectedTab);
  }

  addTab(tab: Tab) {
    this.tabs.push(tab);
  }
}
